import React, { memo } from 'react';
import bem from 'utils/bem';
import FeedbackForm from 'forms/forms/FeedbackForm';
import Text from 'components/Text';
import './index.sass';

const { cnBlock, el } = bem('feedback-form-block');
const FeedbackFormBlock = ({ className, title, text = null, userAgreementMod, buttonMod }) => {
    return (
        <div className={ cnBlock(className) }>
            <div className={ el('text-block') }>
                <div className={ el('title') }><Text serif>{ title }</Text></div>
                { text && <div className={ el('text') }><Text>{ text }</Text></div> }
            </div>
            <div className={ el('form-block') }>
                <FeedbackForm buttonMod={ buttonMod } userAgreementMod={ userAgreementMod }/>
            </div>
        </div>
    )
}

export default memo(FeedbackFormBlock);
